import React, { memo } from 'react';
import StyleToggle from '@Components/Common/StyleToggle';
import SpaceWrapper from '@Components/Layout/SpaceWrapper';

function StyleProviderDemo(): React.ReactElement {
  return (
    <SpaceWrapper padding={24}>
      <StyleToggle />
    </SpaceWrapper>
  );
}

export default memo(StyleProviderDemo);
